(function () {
    'use strict';

    angular
        .module('app.search')
        .factory('SearchService', AccountService);

    AccountService.$inject = ['$http', '$q'];

    function AccountService($http, $q) {
        var service = {
            searchProduct: searchProduct,
            searchCategory: searchCategory,
            getLastViewProducts: getLastViewProducts
        };

        return service;

        function searchProduct(search) {
            var deferred = $q.defer();
            var url = "/General/SearchProduct?search=" + search;

            $http.get(url)
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function searchCategory(search) {
            var deferred = $q.defer();
            var url = "/General/SearchCategory?search=" + search;

            $http.get(url)
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getLastViewProducts() {
            var deferred = $q.defer();
            var url = "General/LastViewProducts";

            $http.get(url)
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }
    }
})();